const getInitState = () => ({
	communityId: null,
	systemId: null,
});

export default {
	namespaced: true,
	state: getInitState(),

	getters: {
		community: (state, getters, rootState, rootGetters) =>
			rootGetters["communities/itemById"](state.communityId),

		system: (state, getters, rootState, rootGetters) =>
			rootGetters["rooms/item"](state.systemId),
	},

	mutations: {
		setCommunityId(state, communityId) {
			if (communityId) {
				this._vm.$log(`Session: Community selected`);
			}
			state.communityId = communityId;
		},

		setSystemId(state, systemId) {
			if (systemId) {
				this._vm.$log(`Session: Room selected`);
			}
			state.systemId = systemId;
		},

		resetState(state) {
			Object.assign(state, getInitState());
		},
	},
};
